import { render, staticRenderFns } from "./CategoryDrawer.vue?vue&type=template&id=dd1f87f6&scoped=true"
import script from "./CategoryDrawer.vue?vue&type=script&lang=js"
export * from "./CategoryDrawer.vue?vue&type=script&lang=js"
import style0 from "./CategoryDrawer.vue?vue&type=style&index=0&id=dd1f87f6&prod&lang=scss&scoped=true"
import style1 from "./CategoryDrawer.vue?vue&type=style&index=1&id=dd1f87f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1f87f6",
  null
  
)

export default component.exports